export default (props: any) => {
  return <header className="header__section">{props.children}</header>;
};
